import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import NexusModals from './components/NexusModals';
import { PlexarianLoaderScreen } from './components/PlexarianLoader';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NexusModals />
    <Suspense fallback={<PlexarianLoaderScreen message="Cargando Nexus…" fullScreen minHeight="100vh" />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (process.env.NODE_ENV === 'production') {
  const RECOVER_KEY = 'nexus-chunk-recover-2';
  const recoverFromBadChunk = () => {
    if (sessionStorage.getItem(RECOVER_KEY)) return;
    sessionStorage.setItem(RECOVER_KEY, '1');
    const clear = async () => {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
      }
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((reg) => reg.unregister()));
      }
    };
    clear().finally(() => window.location.reload());
  };
  window.addEventListener('error', (event) => {
    const el = event?.target;
    const message = String(event?.message || '');
    if (/ChunkLoadError|Loading chunk/.test(message)) {
      recoverFromBadChunk();
      return;
    }
    const tag = el && el.tagName;
    const src = el?.src || el?.href || '';
    if ((tag === 'SCRIPT' || tag === 'LINK') && /\/static\//.test(String(src))) {
      recoverFromBadChunk();
    }
  }, true);
  window.addEventListener('unhandledrejection', (event) => {
    const message = String(event?.reason?.message || event?.reason || '');
    if (/ChunkLoadError|Loading chunk/.test(message)) recoverFromBadChunk();
  });
}

const swHost = typeof window !== 'undefined' ? window.location.hostname : '';
const swOnMarketingSite = swHost === 'www.plexarian.com' || swHost === 'plexarian.com';
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator && !swOnMarketingSite) {
  const registerSw = () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[PWA] No se pudo registrar el service worker:', err?.message || err);
    });
  };
  window.addEventListener('load', () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(registerSw, { timeout: 4000 });
    } else {
      setTimeout(registerSw, 2500);
    }
  });
}
